// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

// Main pages
import Home from "./pages/Home";
import About from "./pages/About";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";
import Team from "./pages/Team";

// Admin
import AdminLogs from "./pages/AdminLogs";
import AdminDashboard from "./pages/AdminDashboard";
import SOCMonitor from "./pages/admin/SOCMonitor";
import AdminUsers from "./pages/admin/AdminUsers";

// Profile & Dashboard
import Profile from "./pages/dashboard/profile";
import Dashboard from "./pages/dashboard/Dashboard";

// Articles
import Articles from "./pages/Articles";
import ArticleTemplate from "./pages/articles/ArticleTemplate";

// AI Platform
import AILayout from "./pages/ai/AILayout";
import CyberAI from "./pages/ai/CyberAI";
import AIDashboardHome from "./pages/ai/AIDashboardHome";
import ReconTools from "./pages/ai/ReconTools";
import AttackLab from "./pages/ai/AttackLab";
import ForensicsLab from "./pages/ai/ForensicsLab";
import Reports from "./pages/ai/Reports";

// CTF
import CTF from "./pages/ctf/CTF";
import ChallengeDetails from "./pages/ctf/ChallengeDetails";

// Auth
import Signup from "./pages/auth/Signup";
import Login from "./pages/auth/Login";
import VerifyOTP from "./pages/auth/VerifyOTP";
import VerifyEmail from "./pages/auth/VerifyEmail";

// Protection
import ProtectedRoute from "./components/ProtectedRoute";
import ProtectedAdminRoute from "./components/ProtectedAdminRoute";

// Leaderboard
import Leaderboard from "./pages/leaderboard/Leaderboard";

// Training
import Training from "./pages/training/Training";
import Courses from "./pages/Courses";
import CourseDetails from "./pages/training/CourseDetails";
import Memberships from "./pages/training/Memberships";
import TrainingPackages from "./pages/training/TrainingPackages";
import CareerTraining from "./pages/training/CareerTraining";
import ForOrganizations from "./pages/training/ForOrganizations";
import ListCourses from "./pages/training/ListCourses";
import TrainingPaths from "./pages/training/TrainingPaths";
import ComparePackages from "./pages/training/ComparePackages";

function App() {
  return (
    <Router>
      <div className="bg-black min-h-screen text-green-400 flex flex-col pt-24">
        <Navbar />

        <div className="flex-grow">
          <Routes>

            {/* Main */}
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/team" element={<Team />} />

            {/* Profile */}
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />

            {/* Articles */}
            <Route path="/articles" element={<Articles />} />
            <Route path="/articles/:slug" element={<ArticleTemplate />} />

            {/* AI Platform */}
            <Route path="/ai" element={<AILayout />}>
              <Route index element={<CyberAI />} />
              <Route path="dashboard" element={<AIDashboardHome />} />
              <Route path="recon" element={<ReconTools />} />
              <Route path="lab" element={<AttackLab />} />
              <Route path="forensics" element={<ForensicsLab />} />
              <Route path="reports" element={<Reports />} />
            </Route>

            {/* Admin */}
            <Route
              path="/admin"
              element={
                <ProtectedAdminRoute>
                  <AdminDashboard />
                </ProtectedAdminRoute>
              }
            />

            <Route
              path="/admin/users"
              element={
                <ProtectedAdminRoute>
                  <AdminUsers />
                </ProtectedAdminRoute>
              }
            />

            <Route
              path="/admin/logs"
              element={
                <ProtectedAdminRoute>
                  <AdminLogs />
                </ProtectedAdminRoute>
              }
            />

            <Route
              path="/admin/soc"
              element={
                <ProtectedAdminRoute>
                  <SOCMonitor />
                </ProtectedAdminRoute>
              }
            />

            {/* CTF */}
            <Route path="/ctf" element={<CTF />} />
            <Route
              path="/ctf/:title"
              element={
                <ProtectedRoute>
                  <ChallengeDetails />
                </ProtectedRoute>
              }
            />

            {/* Auth */}
            <Route path="/signup" element={<Signup />} />
            <Route path="/login" element={<Login />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/verify-otp" element={<VerifyOTP />} />

            {/* Dashboard */}
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />

            {/* Leaderboard */}
            <Route path="/leaderboard" element={<Leaderboard />} />

            {/* Training & Courses */}
            <Route path="/training" element={<Training />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/courses/:id" element={<CourseDetails />} />
            <Route path="/memberships" element={<Memberships />} />
            <Route path="/training-packages" element={<TrainingPackages />} />
            <Route path="/career-training" element={<CareerTraining />} />
            <Route path="/for-organizations" element={<ForOrganizations />} />
            <Route path="/list-courses" element={<ListCourses />} />
            <Route path="/training-paths" element={<TrainingPaths />} />
            <Route path="/compare-packages" element={<ComparePackages />} />

          </Routes>
        </div>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
